import Store from '~/store/undux';

const useSetVideo = () => {
  const store = Store.useStore();
  if(!store || !store.set) {
    return false;
  }

  const setMediaRegion = store.set('mediaRegion');
  const setPageType = store.set('pageType');
  const setPlaylistInfo = store.set('playlistInfo');

  const updateStore = (trayindex, itemindex, playlists, activeChip='', mediaregion='', pagetype='') => {
    if(mediaregion) {
      setMediaRegion(mediaregion);
    }

    if(pagetype) {
      setPageType(pagetype);
    }

    const storePlaylistInfo = store.get('playlistInfo');
    const playlistsFallback = playlists || storePlaylistInfo.playlists || [[]]

    setPlaylistInfo({      
      activeChip: activeChip,
      activePlaylist: playlistsFallback[trayindex || 0]?.items,
      playlistIndex: parseInt(itemindex || 0, 10),
      playlists: playlistsFallback,
      trayIndex: parseInt(trayindex || 0, 10),
    });
  }

  const setVideo = e => {
    e.preventDefault();
    const { trayindex, index, activechip, mediaregion, pagetype } = e.currentTarget.dataset;
    // Support buttons that use data-index (e.g. YouTube carousel) as well as data-itemindex
    const playlistIndex = index;
    updateStore(trayindex, playlistIndex, null, activechip, mediaregion, pagetype);
  }

  return {
    setVideo,
    updateStore
  };
};

export default useSetVideo;
